<template>
   <div>
      <v-container>
         <v-dialog
            v-model="modal"
            persistent
            width="500px"
            height="550px"
            @keydown.esc="cancelBtnClick"
         >
            <v-sheet height="82vh">
               <v-row>
                  <v-col cols="12">
                     <v-toolbar
                        flat
                        dense
                        :class="$globalstore.toolbar_headerclass"
                     >
                        <v-toolbar-title>
                           <template v-if="$vuetify.breakpoint.mdAndUp">
                              <span>Select Student</span>
                           </template>
                           <template v-else>
                              Students
                           </template>
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn @click.native="cancelBtnClick" class="mx-2"
                           >Cancel
                        </v-btn>
                        <v-btn @click.native="OkBtnClick" class="mx-2"
                           >OK
                        </v-btn>
                     </v-toolbar>
                  </v-col>
               </v-row>

               <v-row no-gutters justify="space-around">
                  <v-col cols="8" md="8">
                     <v-btn
                        block
                        color="primary"
                        class="ma-1"
                        @click="allStudentBtnClick"
                     >
                        All Students
                     </v-btn>
                  </v-col>
               </v-row>

               <v-row no-gutters>
                  <v-col cols="12" md="12">
                     <v-expansion-panels>
                        <v-expansion-panel class="py-0">
                           <v-expansion-panel-header>
                              Year Group
                           </v-expansion-panel-header>

                           <v-expansion-panel-content class="py-0">
                              <v-row dense class="py-0">
                                 <v-checkbox
                                    v-for="yr in yeargroup"
                                    :key="yr.year"
                                    v-model="selectedyeargroup"
                                    dense
                                    class="mr-1 my-0 py-0"
                                    :label="'Year ' + yr.year"
                                    :value="yr.code"
                                 ></v-checkbox>
                              </v-row>
                           </v-expansion-panel-content>
                        </v-expansion-panel>

                        <v-expansion-panel
                           :disabled="selectedyeargroup.length > 0"
                           class="py-0"
                        >
                           <v-expansion-panel-header class="py-0 ma-0">
                              Individual Students
                           </v-expansion-panel-header>
                           <v-expansion-panel-content class="py-0">
                              <v-text-field
                                 label="Search"
                                 v-model="studentsearch"
                              ></v-text-field>
                              <v-data-table
                                 dense
                                 v-model="selectedstudents"
                                 height="50vh"
                                 :headers="student_header"
                                 :items="studentdata"
                                 fixed-header
                                 item-key="school_id"
                                 @click:row="studentRowClick"
                                 :single-select="false"
                                 :show-select="true"
                                 :search="studentsearch"
                              >
                              </v-data-table>
                           </v-expansion-panel-content>
                        </v-expansion-panel>
                     </v-expansion-panels>
                  </v-col>
               </v-row>
            </v-sheet>
         </v-dialog>
      </v-container>
   </div>
</template>

<script>
   import { RecipientConst } from "@/common/recipientconstant.js";

   export default {
      inject: ["ShowMessage"],

      data() {
         return {
            resolve: null,
            reject: null,
            modal: false,
            yeargroup: RecipientConst.YEAR_GROUP,
            rcpttype: RecipientConst.RECIPIENT_TYPE,
            rcptcatglist: RecipientConst.RECIPIENT_CATEGORY,
            rcptgroup: RecipientConst.RECIPIENT_GROUP,
            rcptcode: RecipientConst.RECIPIENT_CODE,
            selectedstudents: [],
            selectedrecipient: [],
            selectedyeargroup: [],
            studentdata: [],
            studentsearch: "",

            student_header: [
               {
                  text: "Name",
                  value: "student_fullname",
                  class: this.$globalstore.table_headerclass,
               },
               {
                  text: "Year",
                  value: "ncyear",
                  class: this.$globalstore.table_headerclass,
               },
            ],
         };
      },

      methods: {
         studentRowClick(item, row) {
            row.select(!row.isSelected);
         },

         open() {
            //this.selectedrecipient = selectedrecipient;

            this.loadStudents();

            this.modal = true;
            return new Promise((resolve, reject) => {
               this.resolve = resolve;
               this.reject = reject;
            });
         },

         allStudentBtnClick() {
            let grp = this.rcptgroup.find(
               (x) => x.id === this.rcptcode.ALL_STUDENTS
            );

            let recipient = new Array();

            let rcpt = {
               type: this.rcpttype.STUDENTS,
               code: this.rcptcode.ALL_STUDENTS,
               id: this.rcptcode.ALL_STUDENTS,
               text: grp.text,
               color: grp.color,
            };
            recipient.push(rcpt);

            this.resolve(true);
            this.modal = false;
            this.$emit("return-recipient", recipient);
         },

         OkBtnClick() {
            if (this.selectedyeargroup.length > 0) {
               this.selectedyeargroup.sort();
               let recipient = new Array();
               for (let i = 0; i < this.selectedyeargroup.length; i++) {
                  var year = this.selectedyeargroup[i];
                  let grp = this.rcptgroup.find((x) => x.id === year);
                  let rcpt = {
                     type: this.rcpttype.STUDENTS,
                     code: year,
                     id: year,
                     text: grp.text,
                     color: grp.color,
                  };
                  recipient.push(rcpt);
               }
               this.resolve(true);
               this.modal = false;
               this.$emit("return-recipient", recipient);
            } else if (this.selectedstudents.length > 0) {
               let recipient = new Array();
               for (let i = 0; i < this.selectedstudents.length; i++) {
                  var student = this.selectedstudents[i];
                  var grp = this.rcptgroup.find(
                     (x) => x.id === this.rcptcode.INDIVIDUAL_STUDENT
                  );
                  let rcpt = {
                     type: this.rcpttype.STUDENTS,
                     code: this.rcptcode.INDIVIDUAL_STUDENT,
                     id: student.school_id,
                     text: student.student_fullname,
                     color: grp.color,
                  };
                  recipient.push(rcpt);
                  this.resolve(true);
                  this.modal = false;
                  this.$emit("return-recipient", recipient);
               }
            } else {
               this.resolve(false);
               this.modal = false;
            }
         },

         cancelBtnClick() {
            this.resolve(false);
            this.modal = false;
         },

         async loadStudents() {
            await this.$http({
               url: "/common/recipientstudent.php",
               headers: { "Content-Type": "application/x-www-form-urlencoded" },
               data: {
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     this.studentdata = response.data.studentdata;
                  }
               }
            });
         },
      },
   };
</script>
